import { useRef } from "react";
import { fetchData } from "../../fetcher";
import TheMallOutletLayout from "../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import EventExtra from "../../components/EventExtra/EventExtra";


const ExtraContainer = ({ menuItems, dataContent }) => {
  const scrollToRef = useRef(null)

  return (
    <TheMallOutletLayout menuItems={menuItems}>
      {dataContent.event.isextra && <EventExtra event={dataContent.event} />}
    </TheMallOutletLayout>
  );
};

ExtraContainer.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  const { slug } = context.query

  const resmenu = await fetchData("/init", context.query.locale)
  const data = await fetchData(slug, context.query.locale);

  //console.log(slug, data.event);
  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent
  }
}

export default ExtraContainer;